import React, { useState, useEffect } from 'react';
// import GSheetReader from 'g-sheets-api';
import './service.css'; // The CSS file for styling the layout
import NewNavbar from './Navbar';

function Service() {
  const [services, setServices] = useState([]);
  const [ServiceH1, setServiceH1] = useState("");

  // Fetch data from Google Sheets
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => {
        setServiceH1(data.ServiceH1);
        const serviceData = [];
        for (const [key, value] of Object.entries(data)) {
          if (key.endsWith("Service")) {
            serviceData.push({ name: key.slice(0, -7), imageUrl: value });
          }
        }

        setServices(serviceData);
      })
      .catch(error => console.error('Error loading config:', error));
  }, []);

  return (
    <div>
      <NewNavbar />
      <div className="newservice-container">
        <h1>{ServiceH1}</h1>
        <div className="newservices-grid">
          {services.map((service, index) => (
            <div key={index} className="newservice-card">
              <h2>{service.name}</h2>
              <img src={service.imageUrl} alt={service.name} className="newservice-image" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Service;
